import { createSelector } from 'reselect';
import get from 'transmute/get';
import { getCurrentInbox } from 'conversations-inbox-lib/unified-inbox/public/selectors';
export const getCurrentInboxChannels = createSelector([getCurrentInbox], inbox => get('channels', inbox) || []);